module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card md-layout-item md-size-33"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(this.name))])]), _c('md-card-content', [(_vm.loaded && _vm.stocks && _vm.stocks.length) ? _c('md-list', _vm._l((_vm.stocks), function(stock) {
    return _c('md-list-item', {
      key: stock.id
    }, [_c('router-link', {
      staticClass: "md-list-item-text",
      attrs: {
        "to": {
          name: 'Stock',
          params: {
            stock_id: stock.id
          }
        }
      }
    }, [_vm._v(_vm._s(stock.name))]), _c('span', {
      staticClass: "md-list-action"
    }, [_vm._v(_vm._s('Грузов: ' + stock.freight_count))])], 1)
  })) : _vm._e(), (!_vm.loaded) ? _c('p', [_vm._v("Загрузка...")]) : _vm._e(), (_vm.loaded && (!_vm.stocks || !_vm.stocks.length)) ? _c('p', [_vm._v("У вас не созданно ни одного склада")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09f7f441","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/dashboard/StockDashboard.vue
// module id = 1033
// module chunks = 0